import $ from 'jquery';

const mobileBreakpoint = 640;
const settings = {
  speed: 250,
  ease: 'cubic-bezier(0.165,0.84,0.44,1)', // @easeOutQuart
  slide: '.views-row',
  dots: true,
  arrows: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 960,
      settings: {
        arrows: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: mobileBreakpoint,
      settings: 'unslick',
    },
  ],
};

function Slider(element) {
  this.element = element;
  this.$element = $(element);
  this.ticking = false;
  this.$slickInstance = this.defineInstance();
  this.addListeners();
  this.update();
  this.ready();
}

Slider.prototype = {
  defineInstance() {
    return this.$element.find('.view-content');
  },
  create() {
    this.$slickInstance.slick(settings);
  },
  change() {
    this.requestTick();
  },
  update() {
    this.ticking = false;
    const slick = this.$slickInstance.get(0).slick;
    const disabled = slick ? slick.unslicked : true;

    // If an instance wasn't found and is a larger device, (re)create it.
    if (disabled && window.innerWidth >= mobileBreakpoint) {
      this.create();
    }
  },
  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  },
  addListeners() {
    $(window).on('resize orientationChange', this.change.bind(this));
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Slider;



// WEBPACK FOOTER //
// ./NewsCarousel.js